export default "__VITE_ASSET__cQ8ngO6f__"